import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src626159113/src/next-app/app/(authenticated)/[workspace]/client.tsx");
